const selectorsProfile = new Map();
export const getItems = () => selectorsProfile;
export const clear = () => selectorsProfile.clear();
export const getItem = (key) => selectorsProfile.get(key);
export const setItem = (key, value) => selectorsProfile.set(key, value);
